export function RoleBadge(props: { role: string }) {
  return <span class={`px-2 py-0.5 text-xs rounded border ${props.role === "owner" ? "bg-purple-900/40 text-purple-300 border-purple-700" : props.role === "manager" ? "bg-blue-900/40 text-blue-300 border-blue-700" : "bg-emerald-900/40 text-emerald-300 border-emerald-700"}`}>{props.role}</span>;
}
